import { OrderProvider, OrderFormat } from '@caresend/types';
import { isNonEmptyArray } from '@caresend/utils';
import { OrderFlowRouteName } from '../../../../router/routes/orderFlow/model.js';
import { isLabOfficeUser } from '../../../helpers.js';
import { getStore } from '../../../helpers/initStore.js';

// ROOT STEPS
const getAdditionalInformationValidationFailures = (route) => {
    var _a, _b;
    const store = getStore();
    const { office } = store.state.office;
    const requireAdditionalInfo = office === null || office === void 0 ? void 0 : office.orderSettings.orderFlowSettings.requireAdditionalInfo;
    if (!requireAdditionalInfo)
        return null;
    const { bookingID } = route.params;
    const booking = bookingID
        ? (_a = store.state.orderFlow.draftBookings) === null || _a === void 0 ? void 0 : _a[bookingID]
        : undefined;
    if (!booking)
        return ['Missing booking'];
    const { labOrderID, patientShipmentTrackingNumber, sampleShipmentTrackingNumber, } = booking;
    const { patientAlreadyHasTheKit } = store.state.orderFlow.localState;
    const isOfflineScheduling = (_b = store.state.orderFlow.draftOrder) === null || _b === void 0 ? void 0 : _b.offlineScheduling;
    if (!labOrderID)
        return ['Missing order ID'];
    if (isOfflineScheduling)
        return null;
    if (!patientShipmentTrackingNumber && !patientAlreadyHasTheKit) {
        return ['Missing patient shipment tracking number'];
    }
    if (!sampleShipmentTrackingNumber) {
        return ['Missing sample shipment tracking number'];
    }
    return null;
};
const getPartialBookingValidationFailures = (booking) => {
    var _a, _b, _c;
    const store = getStore();
    const { flowSettings } = store.state.orderFlow.data;
    const failures = [];
    if (!booking.provider || booking.provider === OrderProvider.PRESCRIBER) {
        const bookingOrderFormat = (_b = (_a = flowSettings.orderFormatByBookingID) === null || _a === void 0 ? void 0 : _a[booking.id]) !== null && _b !== void 0 ? _b : flowSettings.orderingFormat;
        if (bookingOrderFormat === OrderFormat.PDF) {
            if (!((_c = booking.documents) === null || _c === void 0 ? void 0 : _c.length)) {
                failures.push('At least one patient booking has no documents');
            }
        }
    }
    else if (booking.provider === OrderProvider.PATIENT_OR_CONTACT && !booking.providerID) {
        failures.push('At least one patient booking has no assigned order provider');
    }
    if (isNonEmptyArray(failures))
        return failures;
    return null;
};
const getOrderFlowVisitOverviewStepFailures = () => {
    var _a, _b, _c;
    const store = getStore();
    const { orderFlow } = store.state;
    const failures = {};
    if (!Object.values((_a = orderFlow.draftBookings) !== null && _a !== void 0 ? _a : {}).length) {
        failures['Add at least one patient to your order'] = true;
    }
    else {
        Object.values((_b = orderFlow.draftBookings) !== null && _b !== void 0 ? _b : {}).forEach((booking) => {
            const bookingFailures = getPartialBookingValidationFailures(booking);
            bookingFailures === null || bookingFailures === void 0 ? void 0 : bookingFailures.forEach((failure) => {
                failures[failure] = true;
            });
        });
    }
    if (!((_c = orderFlow.draftOrder) === null || _c === void 0 ? void 0 : _c.officeID) && !isLabOfficeUser()) {
        failures['Select an office'] = true;
    }
    const failuresArray = Object.keys(failures);
    if (isNonEmptyArray(failuresArray))
        return failuresArray;
    return null;
};
/**
 * Validators to determine when the `Next` button should be enabled on
 * order flow steps.
 */
const orderFlowStepValidators = {
    [OrderFlowRouteName.ORDER_FLOW_ADDITIONAL_INFORMATION]: getAdditionalInformationValidationFailures,
    [OrderFlowRouteName.ORDER_FLOW_VISIT_OVERVIEW]: (_) => getOrderFlowVisitOverviewStepFailures(),
};

export { getAdditionalInformationValidationFailures, getOrderFlowVisitOverviewStepFailures, orderFlowStepValidators };
